import { tryCatch } from '@/types/utils';
import type { CommonResponse } from '@/types/response';
import bs58 from 'bs58';
import type { VersionedTransaction } from '@solana/web3.js';
import type { WalletSendTransactionFunc } from '@/types/wallet';

async function sendTransaction({
  transaction,
  sendTransaction,
}: {
  transaction: VersionedTransaction;
  sendTransaction: WalletSendTransactionFunc;
}): Promise<CommonResponse<string>> {
  return tryCatch<string>(async () => {
    const res = await sendTransaction({ transaction });

    if (!res.ok) {
      return res;
    }

    if (isValidSolanaSignature(res.data) === false) {
      return {
        ok: false,
        error: new Error('Invalid transaction signature received'),
      };
    }

    return res;
  });
}

export function isValidSolanaSignature(signature: string): boolean {
  try {
    // return true
    const decoded = bs58.decode(signature);
    return decoded.length === 64;
  } catch {
    return false;
  }
}

export const sendTransactionService = { sendTransaction };
